<ui-form-abstract-note
    [pending]="pending$ | async"
    [noteRequired]="noteRequired"
    [resetFieldAfterSubmit]="resetFieldAfterSubmit"
    (submitForm)="handlerClickConfirm($event)" />
